<template>
  <div class="profiles-parent">
    <div
      v-for="profile in profiles"
      :key="profile.steamid"
    >
      <Profile
        :id="profiles.indexOf(profile)"
        :profile="profile"
        @removeProfile="removeProfile"
      />
    </div>
  </div>
</template>

<script>
import Profile from "./Profile.vue";
export default {
  name: "Profiles",
  components: {
    Profile
  },
  props: {
    profiles: {
      type: Array,
      default: null
    }
  },
  data: function() {
    return {};
  },
  methods: {
    /**
     * Pass through $emit from child to App component.
     * @param profile - instance of profile being removed.
     */
    removeProfile: function(profile) {
      this.$emit("removeProfile", profile);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profiles-parent {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
}
@media only screen and (max-width: 640px) {
  .profiles-parent {
    grid-template-columns: 100%;
  }
}
</style>